import { Pressable, Text, View } from 'react-native'
import { styled } from '~/utils'

export const Wrapper = styled(Pressable, theme => {
  return {
    base: {
      position: 'absolute',
      zIndex: theme.zindexOverlay,
    },
    variants: {
      side: {
        bottom: {
          justifyContent: 'flex-end',
        },
        top: {
          justifyContent: 'flex-end',
          flexDirection: 'column-reverse',
        },
        right: {
          flexDirection: 'row',
          justifyContent: 'flex-end',
        },
        left: {
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end',
        },
      },
      align: {
        middle: {
          alignItems: 'flex-start',
        },
        start: {
          alignItems: 'flex-start',
        },
        end: {
          alignItems: 'flex-start',
        },
      },
    },
  }
})

export const Container = styled(View, theme => {
  return {
    base: {
      // Sizing
      minWidth: theme.sizingHuge,

      // Spacing
      padding: theme.spacingInlineFourpulse,
      gap: 8,

      // Layout & Positioning
      flexDirection: 'row',
      alignItems: 'center',
      zIndex: theme.zindexOverlay,
      bottom: 0,

      // Colors
      backgroundColor: theme.colorFillNeutralDefault,

      // Borders
      borderRadius: theme.borderRadiusLargecontainer,
      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorBorderNeutralDefault,

      // Shadows
      shadowColor: '#71768E',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: theme.opacityLower / 100,
      shadowRadius: theme.borderRadiusSmallcontainer,
      elevation: 4,
    },
  }
})

export const Content = styled(Text, theme => {
  return {
    base: {
      flexShrink: 1,

      // Typography
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeThreepulse,
      fontFamily: 'RDModern-Regular',
    },
  }
})
